module.exports = __webpack_public_path__ + "static/media/ttl-2.f0b924a7.svg";